// extracted by mini-css-extract-plugin
export default {"text":"Icons_text__2KQUQ","svg":"Icons_svg__1DR+V","icon":"Icons_icon__ck7JQ","link":"Icons_link__U9laE","social":"Icons_social__L0r25","fontsmall":"Icons_fontsmall__R9eNe"};